import Terminal from "./terminal";
const TerminalShow = () => {
  return <Terminal />;
};
export default TerminalShow;
